import * as React from 'react';
import TextField from "@material-ui/core/TextField";
import Translate from '../../common/functions/translate';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import { ProductFilterSettingsModel } from '../../models/product/productFilterSettingsModel';
import CategoryService from '../../services/categoriesService';
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import Paper from '@material-ui/core/Paper';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number,
  productSettings: ProductFilterSettingsModel,
  //categoryFilterLabel: string
}

interface IState {
  filterText: string,
  articleNumber: string;
  brand: string;
  article: string;
  power: string;
  supplier: string;
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      }
    }
  },
  palette: {
    primary: blue
  }
});

export class ProductFilter extends React.Component<IProps, IState>  {
  categoryService = new CategoryService();

  constructor(props) {
    super(props);
    this.state = {
      articleNumber: this.props.productSettings && this.props.productSettings.articleNumber ? this.props.productSettings.articleNumber : '',
      brand: this.props.productSettings && this.props.productSettings.brand ? this.props.productSettings.brand : '',
      power: this.props.productSettings && this.props.productSettings.power ? this.props.productSettings.power : '',
      supplier: this.props.productSettings && this.props.productSettings.supplier ? this.props.productSettings.supplier : '',
      article: this.props.productSettings && this.props.productSettings.article ? this.props.productSettings.article : '',
      filterText: ''
    };
  }

  componentDidMount() {
  }

  handleChange = (key, value) => {
    let articleNumber = this.state.articleNumber;
    let brand = this.state.brand;
    let power = this.state.power;
    let supplier = this.state.supplier;
    let article = this.state.article;

    if (key === 'articleNumber') {
      articleNumber = value;
    }

    if (key === 'article') {
      article = value;
    }

    if (key === 'brand') {
      brand = value;
    }

    if (key === 'power') {
      power = value;
    }

    if (key === 'supplier') {
      supplier = value;
    }

    const filterText = this.generateFilterText(articleNumber, brand, power, supplier, article);

    this.setState({
      articleNumber: articleNumber,
      brand: brand,
      power: power,
      supplier: supplier,
      filterText: filterText,
      article: article
    });
  };

  generateFilterText = (articleNumber: string, brand: string, power: string, supplier: string, article: string) => {
    let result = '';

    if (articleNumber) {
      result += Translate("Article number") + " <strong>'" + articleNumber + "'</strong>, ";
    }

    if (article) {
      result += Translate("Article") + " <strong>'" + article + "'</strong>, ";
    }

    if (brand) {
      result += Translate("Brand") + " <strong>'" + brand + "'</strong>, ";
    }

    if (power) {
      result += Translate("Power") + " <strong>'" + power + "'</strong>, ";
    }

    if (supplier) {
      result += Translate("Supplier") + " <strong>'" + supplier + "'</strong>, ";
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = () => {
    this.props.onSearchClick(this.state.articleNumber, this.state.brand, this.state.power, this.state.supplier, this.state.article);
  }

  handleClearButtonClick = () => {
    this.setState({
      articleNumber: '',
      brand: '',
      power: '',
      supplier: '',
      filterText: '',
      article: '',
    });

    this.props.onSearchClick('', '', '', '');
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick();
    }
  }

  render() {

    let { filterText } = this.state;
    // if (this.props.categoryFilterLabel) {
    //   if (filterText) {
    //     filterText += ", " + Translate("Category") + " <strong>'" + this.props.categoryFilterLabel + "'</strong> ";
    //   }
    //   else {
    //     filterText += Translate("Category") + " <strong>'" + this.props.categoryFilterLabel + "'</strong> ";
    //   }
    // }

    return (
      <Paper style={{ padding: 10, marginBottom: 15, backgroundColor: "#f5f5f5" }} >
        <div>
          <MuiThemeProvider theme={theme}>
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="articleNumber"
              label={Translate("Article number")}
              style={{ marginRight: 10 }}
              type="text"
              onChange={(e) => this.handleChange('articleNumber', e.target['value'])}
              value={this.state.articleNumber}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="article"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Article")}
              onChange={(e) => this.handleChange('article', e.target['value'])}
              value={this.state.article}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="brand"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Brand")}
              onChange={(e) => this.handleChange('brand', e.target['value'])}
              value={this.state.brand}
            />
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="power"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Power")}
              onChange={(e) => this.handleChange('power', e.target['value'])}
              value={this.state.power && this.state.power ? this.state.power : ""}
            />

            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="supplier"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Supplier")}
              onChange={(e) => this.handleChange('supplier', e.target['value'])}
              value={this.state.supplier && this.state.supplier ? this.state.supplier : ""}
            />

            {/* <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="model"
              type="text"
              style={{ marginRight: 10 }}
              label={Translate("Model")}
              onChange={(e) => this.handleChange('model', e.target['value'])}
              value={this.state.productSettings && this.state.productSettings.model ? this.state.productSettings.model : ""}
            /> */}

          </MuiThemeProvider>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
          <div style={{ fontSize: "0.9em" }}>
            {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
            {filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: filterText }}></span>
          </div>
          <div>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: 10 }}
              size="small"
              onClick={() => this.handleSearchButtonClick()}
            >
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
              {Translate("Filter")}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => this.handleClearButtonClick()}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10 }} />
              {Translate("Clear")}
            </Button>
          </div>
        </div>
      </Paper>
    )
  }
}

export default ProductFilter;
